import { useEffect } from 'react';
import {
  IS_TELEGRAM,
  onThemeChanged,
  disableVerticalSwipes,
  showBackButton,
  hideBackButton,
  applyViewportHeight,
  onViewportChanged,
} from './telegram';
import { applyTelegramTheme } from './theme';

interface ChromeOptions {
  activePanelOpen: boolean;
  onCloseActivePanel: () => void;
}

/* Applies Telegram theme + viewport + swipe behavior once, and keeps the
   Telegram BackButton in sync with whether an in-app panel is open. */
export function useTelegramChrome({
  activePanelOpen,
  onCloseActivePanel,
}: ChromeOptions): void {
  // One-time theme + viewport + swipe setup.
  useEffect(() => {
    if (!IS_TELEGRAM) return;
    applyTelegramTheme();
    applyViewportHeight();
    disableVerticalSwipes();
    const offTheme = onThemeChanged(applyTelegramTheme);
    // The viewport grows when the Mini App expands; keep the CSS var in sync.
    const offViewport = onViewportChanged(applyViewportHeight);
    return () => {
      offTheme();
      offViewport();
    };
  }, []);

  // BackButton mirrors the active panel.
  useEffect(() => {
    if (!IS_TELEGRAM) return;
    if (activePanelOpen) {
      showBackButton(onCloseActivePanel);
    } else {
      hideBackButton();
    }
    return () => hideBackButton();
  }, [activePanelOpen, onCloseActivePanel]);
}
